import { useState } from "react";
import { Link, useSearchParams } from "react-router";
import { useI18n } from "../i18n/I18nProvider";
import { marketApi } from "../market/api";

/**
 * /emails-tienda?accion=baja&u=&s=&t= ("No recibir más de esta tienda") or ?accion=spam&u=&c=&t=
 * ("Denunciar spam"), from a shop's email. A click confirms (mail scanners only GET).
 */
export function ShopEmailActionPage() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const spam = params.get("accion") === "spam";
  const u = params.get("u") ?? "";
  const token = params.get("t") ?? "";
  const target = spam ? (params.get("c") ?? "") : (params.get("s") ?? "");
  const [state, setState] = useState<"idle" | "busy" | "done" | "error">(u && token && target ? "idle" : "error");

  const confirm = async () => {
    setState("busy");
    try {
      if (spam) await marketApi.shopSpam(u, target, token);
      else await marketApi.shopUnsubscribe(u, target, token);
      setState("done");
    } catch {
      setState("error");
    }
  };

  return (
    <section className="container section narrow">
      <h1>{t("shopmail.title")}</h1>
      {state === "done" ? (
        <p role="status">{t(spam ? "shopmail.spamDone" : "shopmail.optoutDone")}</p>
      ) : state === "error" ? (
        <p className="field-error">{t("unsubscribe.invalid")}</p>
      ) : (
        <>
          <p>{t(spam ? "shopmail.spamText" : "shopmail.optoutText")}</p>
          <button type="button" className="btn btn-primary" onClick={confirm} disabled={state === "busy"}>
            {t(spam ? "shopmail.spamButton" : "shopmail.optoutButton")}
          </button>
        </>
      )}
      <p>
        <Link to="/">{t("notFound.back")}</Link>
      </p>
    </section>
  );
}
